var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('edit-creative', { attrs: { "updateRequest": _vm.handleUpdateVersionName, "dialog": _vm.dialog, "id": Number(_vm.id), "schema": _vm.schema, "read-mode": _vm.readMode, "fetchProjectInfo": _vm.handleFetchProject }, on: { "update-success": _vm.handleUpdateSuccess } }, [_vm.$slots.default ? _vm._t("default") : _c('svg-icon', { attrs: { "icon-class": "edit" } })], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };